/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function () {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m)
        return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
            ar.push(r.value);
    }
    catch (error) {
        e = { error: error };
    }
    finally {
        try {
            if (r && !r.done && (m = i["return"]))
                m.call(i);
        }
        finally {
            if (e)
                throw e.error;
        }
    }
    return ar;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2)
        for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar)
                    ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var typePolicies = {
    Customer: {
        merge: true
    },
    FlightsInformationResponse: {
        merge: true,
        fields: {
            flightsSelectedJourneyDetails: {
                merge: function (existing, incoming, _a) {
                    var mergeObjects = _a.mergeObjects;
                    /**
                     * This will happen when no cache entry exists
                     */
                    if (!existing) {
                        return incoming;
                    }
                    /**
                     * When an error occurs, "incoming" will be null, so rather than clobbering the existing
                     * cache entry (if it exists), just return the previous entry in the cache
                     */
                    if (!incoming) {
                        return existing;
                    }
                    /**
                     * When both existing and incoming are present, then merge them into a single list
                     */
                    return existing.map(function (journeyReview, index) { return mergeObjects(journeyReview, incoming[index]); });
                }
            }
        }
    },
    Header: {
        merge: true,
        fields: {
            redDotState: {
                read: function (redDotState) {
                    if (redDotState === void 0) { redDotState = 'NOT_VISIBLE'; }
                    return redDotState;
                }
            }
        }
    },
    Icon: {
        keyFields: false
    },
    Mark: {
        keyFields: false
    },
    Illustration: {
        keyFields: false
    },
    MultiItemDetailsQuery: {
        merge: true
    },
    NotificationQuery: {
        merge: true
    },
    InlineNotification: {
        keyFields: ['type']
    },
    PropertyInfo: {
        merge: true
    },
    ShoppingSortAndFilterSection: {
        keyFields: false
    },
    Query: {
        fields: {
            globalHeader: {
                merge: true
            },
            activityReviews: {
                keyArgs: ['context', 'activityId', 'selections'],
                merge: function (existing, incoming) {
                    var _a, _b;
                    if (existing === void 0) { existing = {}; }
                    return __assign(__assign({}, incoming), { comments: __spreadArray(__spreadArray([], __read(((_a = existing.comments) !== null && _a !== void 0 ? _a : [])), false), __read(((_b = incoming === null || incoming === void 0 ? void 0 : incoming.comments) !== null && _b !== void 0 ? _b : [])), false) });
                }
            },
            propertySearch: {
                keyArgs: ['context', 'destination'],
                merge: function (existing, incoming) {
                    var _a, _b;
                    if (!existing) {
                        return incoming;
                    }
                    if (!incoming) {
                        return existing;
                    }
                    return __assign(__assign({}, incoming), { propertySearchListings: __spreadArray(__spreadArray([], __read(((_a = existing.propertySearchListings) !== null && _a !== void 0 ? _a : [])), false), __read(((_b = incoming.propertySearchListings) !== null && _b !== void 0 ? _b : [])), false) });
                }
            },
            cruiseSearch: {
                keyArgs: ['context', 'cruiseContext', 'searchInput', 'sortBy', 'sortOrder'],
                merge: function (existing, incoming, _a) {
                    var mergeObjects = _a.mergeObjects;
                    /**
                     * This will happen when no cache entry exists
                     */
                    if (!existing) {
                        return incoming;
                    }
                    /**
                     * When an error occurs, "incoming" will be null, so rather than clobbering the existing
                     * cache entry (if it exists), just return the previous entry in the cache
                     */
                    if (!incoming) {
                        return existing;
                    }
                    return mergeObjects(existing, incoming);
                }
            }
        }
    },
    CruiseSearchFilters: {
        merge: true
    },
    SearchFormResults: {
        merge: function (existing, incoming, _a) {
            var mergeObjects = _a.mergeObjects;
            /**
             * This will happen when no cache entry exists
             */
            if (!existing) {
                return incoming;
            }
            /**
             * When an error occurs, "incoming" will be null, so rather than clobbering the existing
             * cache entry (if it exists), just return the previous entry in the cache
             */
            if (!incoming) {
                return existing;
            }
            return mergeObjects(existing, incoming);
        }
    },
    SailingSearchResults: {
        merge: function (existing, incoming, _a) {
            var _b, _c, _d, _e;
            var mergeObjects = _a.mergeObjects, args = _a.args;
            var offset = (args === null || args === void 0 ? void 0 : args.offset) || 0;
            /**
             * This will happen when no cache entry exists
             */
            if (!existing) {
                return incoming;
            }
            /**
             * When an error occurs, "incoming" will be null, so rather than clobbering the existing
             * cache entry (if it exists), just return the previous entry in the cache
             */
            if (!incoming) {
                return existing;
            }
            /**
             * When both existing and incoming are present, then merge them into a single object
             */
            var mergedData = mergeObjects(existing, incoming);
            var mergedSailings = __assign(__assign({}, existing.sailings), incoming.sailings);
            var list = ((_b = existing.sailings) === null || _b === void 0 ? void 0 : _b.list) ? (_c = existing.sailings) === null || _c === void 0 ? void 0 : _c.list.slice(0) : [];
            for (var i = 0; i < ((_e = (_d = incoming.sailings) === null || _d === void 0 ? void 0 : _d.list) === null || _e === void 0 ? void 0 : _e.length); i += 1) {
                list[offset + i] = incoming.sailings.list[i];
            }
            return __assign(__assign({}, mergedData), { sailings: __assign(__assign({}, mergedSailings), { list: list }) });
        }
    },
    TransportationSearchResponse: {
        merge: true
    },
    FlightsServicingResponse: {
        merge: true
    },
    Trips: {
        merge: true
    },
    Trip: {
        merge: true
    },
    OfferDetails: {
        keyFields: false
    },
    SingleUnitOfferDetails: {
        keyFields: false
    },
    ShoppingSelectableFilterOption: {
        keyFields: false
    },
    ActivitySelectedValue: {
        keyFields: ['id', 'value']
    },
    ActivityOffer: {
        keyFields: ['id', 'name', 'availableTime', ['day']]
    },
    ActivityTravelerSelectorDialog: {
        keyFields: false
    },
    ActivityOfferMultiSelectionOption: {
        keyFields: false
    },
    SupplyScoreDetails: {
        merge: true
    },
    PropertyNaturalKey: {
        keyFields: ['ratePlanId']
    },
    PropertyUnit: {
        keyFields: false
    },
    RatePlan: {
        keyFields: false
    },
    RatePlanAmenity: {
        keyFields: false
    },
    Console: {
        merge: true
    },
    SelectedValue: {
        keyFields: ['id', 'value']
    },
    ShoppingTextInputField: {
        keyFields: ['id', 'multiSelections']
    },
    ShoppingStepInputField: {
        keyFields: ['stepInputId']
    },
    VirtualAgentControlInboundMessageGroup: {
        keyFields: false
    },
    VacLite: {
        keyFields: false
    },
    DirectFeedbackPrompt: {
        merge: true
    },
    HelpArticlesResultsView: {
        merge: true
    },
    ContactUsView: {
        merge: true
    }
};

export { typePolicies };
